import { useDispatch } from 'react-redux';
import EmployeeDisplayPreferencesSettings from '../GlobalSetup-EmployeeDisplayPreferences';
import ManagersArchiveSettings from '../GlobalSetup-ManagersArchiveSettings';
import EmployeesArchiveSettings from '../GlobalSetup-EmployeesArchiveSettings';
import './GlobalSetupForm.scss';
import ActionBar from '../ActionBar';
import { UPDATE_GLOBAL_SETUP, updateGlobalSetup } from '../../store/globalSetup';

/**
 * @param {{
 *  isDisabled?: boolean;
 *  isGlobalSetupLoaded: boolean;
 *  globalSetups: GlobalSetup.GlobalSetup;
 *  globalSetupsToReset: GlobalSetup.GlobalSetup;
 * }} param0
 */
const GlobalSetupForm = ({
    isGlobalSetupLoaded,
    globalSetups,
    isDisabled,
    globalSetupsToReset
}) => {
    let i = 0;
    const dispatch = useDispatch();
    const resetAction = {
        type: UPDATE_GLOBAL_SETUP,
        payload: globalSetupsToReset,
    };
    const onSave = () => dispatch(updateGlobalSetup(globalSetups));
    const onReset = () => dispatch(resetAction);

    return (
        <div className="global-setup-form">
            <ManagersArchiveSettings
                isLoading={!isGlobalSetupLoaded}
                globalSetups={globalSetups}
                step={++i}
            />
            <EmployeesArchiveSettings
                isLoading={!isGlobalSetupLoaded}
                globalSetups={globalSetups}
                step={++i}
            />
            <EmployeeDisplayPreferencesSettings
                isDisabled={isDisabled || false}
                globalSetups={globalSetups}
                globalSetupsToReset={globalSetupsToReset}
                isLoading={!isGlobalSetupLoaded}
                step={++i}
            />
            <ActionBar
                isDisabled={isDisabled || false}
                isLoading={!isGlobalSetupLoaded}
                onSave={onSave}
                onReset={onReset}
                className="action-buttons-container"
            />
        </div>
    );
};

export default GlobalSetupForm;
